import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import BellOutlinedSvg from "@ant-design/icons-svg/es/asn/BellOutlined";
import AntdIcon from "../components/AntdIcon";
var BellOutlined = function BellOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BellOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  BellOutlined.displayName = 'BellOutlined';
}
export default /*#__PURE__*/React.forwardRef(BellOutlined);